module.exports = __webpack_public_path__ + "static/media/on-gold.972d2369.png";